import React from 'react'

import { Select as AntSelect } from 'antd'
import PropTypes from 'prop-types'

export const { Option, OptGroup } = AntSelect

export const getWrapperContainer = triggerNode => {
  let container = triggerNode.closest('.ant-modal')

  if (!container) {
    container = triggerNode.closest('.main-content-wrapper')
  }

  if (!container) {
    container = document.body
  }

  return container
}

const Select = props => {
  let { getPopupContainer } = props

  if (getPopupContainer == null) {
    getPopupContainer = getWrapperContainer
  }

  return <AntSelect {...props} getPopupContainer={getPopupContainer} />
}

Select.propTypes = {
  getPopupContainer: PropTypes.func,
}

Select.defaultProps = {
  getPopupContainer: null,
}

export default Select
